/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Issue_Absent_From_MeshInputs */



/**
* | output |
* | --- |
* | "Absent from the mesh network" |
*
* @param {Mesh_Issue_Absent_From_MeshInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_issue_absent_from_mesh = /** @type {((inputs?: Mesh_Issue_Absent_From_MeshInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Issue_Absent_From_MeshInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Absent from the mesh network")
	return /** @type {LocalizedString} */ ("Absente du  Mesh")
});